import { contextFactory } from '@frontend/design-system';

type ContextType = {
  closeModal: () => void;
};

export const [WaitlistTrayContext, useWaitlistTrayContext] = contextFactory<ContextType>();
